export const normalizarArray = (response, key) => {
    const data = response

    if (Array.isArray(data)) return data
    if (Array.isArray(data?.[key])) return data[key]
    if (Array.isArray(data?.items)) return data.items
    if (Array.isArray(data?.data)) return data.data
    if (Array.isArray(data?.results)) return data.results
    if (Array.isArray(data?.rows)) return data.rows
    if (Array.isArray(data?.data?.[key])) return data.data[key]
    if (Array.isArray(data?.data?.items)) return data.data.items
    if (Array.isArray(data?.data?.results)) return data.data.results
    if (Array.isArray(data?.data?.rows)) return data.data.rows

    return []
}

export const normalizarPaginacion = (response, fallbackTotal = 0) => {
    const data = response
    const meta = data?.meta ?? data?.pagination ?? data
    const page = Number(meta?.page ?? meta?.currentPage ?? meta?.pagina ?? meta?.current_page ?? 1)
    const limit = Number(meta?.limit ?? meta?.perPage ?? meta?.pageSize ?? meta?.take ?? meta?.limite ?? fallbackTotal)
    const total = Number(meta?.total ?? meta?.totalItems ?? meta?.count ?? meta?.totalRegistros ?? meta?.total_records ?? fallbackTotal)
    const totalPages = Number(meta?.totalPages ?? meta?.pages ?? meta?.lastPage ?? meta?.last_page ?? meta?.totalPaginas ?? Math.max(Math.ceil(total / (limit || 1)), 1))

    return {
        page: Number.isFinite(page) && page > 0 ? page : 1,
        limit: Number.isFinite(limit) && limit > 0 ? limit : fallbackTotal,
        total: Number.isFinite(total) ? total : fallbackTotal,
        totalPages: Number.isFinite(totalPages) && totalPages > 0 ? totalPages : 1,
    }
}

export const PAGE_SIZE = 24
export const PARAMETROS_TIEMPO_PAGE_SIZE = 100
